<div class="notifiction-content">
  @if (type === 'success') {
  <div
    class="swal2-icon swal2-success swal2-animate-success-icon"
    style="display: flex"
  >
    <div
      class="swal2-success-circular-line-left"
      style="background-color: rgb(255, 255, 255)"
    ></div>
    <span class="swal2-success-line-tip"></span>
    <span class="swal2-success-line-long"></span>
    <div class="swal2-success-ring"></div>
    <div
      class="swal2-success-fix"
      style="background-color: rgb(255, 255, 255)"
    ></div>
    <div
      class="swal2-success-circular-line-right"
      style="background-color: rgb(255, 255, 255)"
    ></div>
  </div>
  } @if (type === 'error') {
  <div
    class="swal2-icon swal2-error swal2-animate-error-icon"
    style="display: flex"
  >
    <span class="swal2-x-mark"
      ><span class="swal2-x-mark-line-left"></span
      ><span class="swal2-x-mark-line-right"></span
    ></span>
  </div>
  }
  <h5 class="wid-140 fw-semibold">{{ title | translate }}</h5>
  <div
    class="message"
    [ngStyle]="{ 'margin-top': type === 'confirm' ? '15px' : '0' }"
  >
    {{ message | translate }}
  </div>
  <div class="button-block text-right">
    <button
      class="btn btn-primary m-r-10"
      (click)="close(true)"
      *ngIf="type === 'confirm'"
    >
      {{ 'button.yes' | translate }}
    </button>
    <button
      class="btn btn-default"
      (click)="close(false)"
      *ngIf="type === 'confirm'"
    >
      {{ 'button.no' | translate }}
    </button>
    <button
      class="btn btn-default"
      (click)="close(false)"
      *ngIf="type !== 'confirm'"
    >
      {{ 'button.close' | translate }}
    </button>
  </div>
</div>
